// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"2c26738f","932":"2c26738f"}[chunkId] + ".chunk.css";
};